import DlsSettings from "./DlsSettings";
export default DlsSettings;
